import { ChildrenProps } from '../../../common/model';

import './style.scss';

export const View = (props: ChildrenProps) => {
    return <div className="tab-list">{props.children}</div>;
};
